import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectApiBaseUrl } from '~/store/env/selectors';

export default createAsyncThunk('accountInfo/login', async (payload, { getState }) => {
  const { username, password } = payload;
  const apiBaseUrl = selectApiBaseUrl(getState());
  const url = `${apiBaseUrl}/auth/login`;

  const params = {
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
      'X-API-VERSION': '2.0',
    },
    body: JSON.stringify({
      email: username,
      password,
    }),
  };

  const httpResponse = await fetch(url, params);
  const response = await httpResponse.json();
  return { ...response, status: httpResponse.status };
});
